import { CategoryTypeEnum } from '@repo/common/enums';
import { VpIconName } from '@vtmn-play/react';

export const categoryIcons: Record<CategoryTypeEnum, VpIconName> = {
  REPAIR: 'maintain-repair',
  BUSINESS: 'trophy',
  BUY_BACK: 'return',
  CUSTOMIZATION: 't-shirt-number',
  PERFORMANCE: 'heart-pulse',
  PERSONAL_SHOPPER: 'hanger',
  RENTAL: 'rent',
  TEST_AND_BUY: 'circularity-shop-rental',
  TEST_E_BIKE: 'lightning',
  SPORT_ACTIVITY: 'run',
  UNAVAILABILITY: 'forbid',
  VISIO_STORE: 'customer-service',
  CUSTOMER_SUPPORT: 'phone',
  UNKNOWN: 'question',
  TEST_ROAD_GRAVEL_BIKE: 'riding',
};
